// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--3-l3n","logo":"styles-module--logo--2R9ax"};